<template>
  <div class="h-full overflow-auto">
    <categoryTitle class="mt-10px mb-5px" title="频率曲线" />
    <div class="w-full h-180px">
      <lineChart ref="lineChartRef" />
    </div>
    <categoryTitle class="mt-10px mb-5px" title="运行特征分析" />
    <div class="w-full h-220px">
      <scatterChart ref="scatterChartRef" />
    </div>
    <categoryTitle class="mt-10px mb-10px" title="设备诊断" />
    <div class="p-12px bg-[#136a7dcc] rounded-md text-white" v-if="diagnostiscDetail.faultLocation">
      <div class="text-16px mb-10px">{{ diagnostiscDetail.faultLocation }}</div>
      <div class="text-14px bg-[#b05303] p-5px mb-10px">
        <div>故障类型：{{ diagnostiscDetail.fault || '--' }}</div>
        <div>危害：{{ diagnostiscDetail.harm || '--' }}</div>
      </div>
      <div v-if="diagnostiscDetail.proposal" class="text-14px bg-[#2d5044] p-5px">
        <div>建议:</div>
        <div>{{ diagnostiscDetail.proposal }}</div>
      </div>
    </div>
    <div class="text-center my-50px text-[#fff] text-12px" v-else>暂无诊断信息</div>

    <!-- 左侧菜单 -->
    <DeviceLedgerTabList
      @changeTab="changeTab"
      activeTab="DeviceDiagnosticsDetail"
      :collapsePanel="collapsePanel"
    ></DeviceLedgerTabList>
  </div>
</template>

<script>
import categoryTitle from '@/components/cockpit/CategoryTitle'
import { DeviceDiagnosisApi } from '@wiz-api/large-screen-management'
import DeviceLedgerTabList from '../DeviceLedger/DeviceLedgerTabList'
import scatterChart from './scatterChart'
import lineChart from './lineChart'

const deviceDiagnosisApi = new DeviceDiagnosisApi()
export default {
  name: 'DeviceDiagnosticsDetail',
  components: {
    DeviceLedgerTabList,
    categoryTitle,
    scatterChart,
    lineChart,
  },
  props: {
    transferProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    collapsePanel: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      detailInfo: {},
      diagnostiscDetail: {},
    }
  },
  watch: {
    transferProps: {
      handler(val) {
        if (val.code && val.code !== this.detailInfo.code) {
          this.detailInfo = val
          this.diagnostiscDetail = {}
          this.$nextTick(async () => {
            this.$refs.lineChartRef.initData(val.code)
            this.$refs.scatterChartRef.initData(val.code)
            if (val.id) {
              this.getDetail()
            } else {
              await this.getDeviceInfo(val.code)
              this.getDetail()
            }
          })
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    changeTab(data) {
      const openEvent = new CustomEvent('openComponent', {
        detail: {
          toCom: {
            code: data.code,
            origin: data.origin,
            name: data.name,
            hideTitle: data.hideTitle,
          },
          position: 'right',
          type: 'tags',
          props: this.transferProps,
        },
      })
      window.dispatchEvent(openEvent)
    },
    async getDetail() {
      if (!this.detailInfo.id) return
      const [err, res] = await deviceDiagnosisApi.get({
        id: this.detailInfo.id
      })
      if (!err) {
        this.diagnostiscDetail = res || {}
      }
    },
    async getDeviceInfo(code) {
      const [err, res] = await deviceDiagnosisApi.getByCode({
        deviceCode: code
      })
      if (!err) {
        this.detailInfo = res || {}
      }
    }
  },
}
</script>

<style lang="scss" scoped></style>
